import { useEffect, useState } from "react";
import { UserRound } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { setStudent } from "@/lib/student";

export const StudentGate = ({ student, onChange }) => {
  const [classes, setClasses] = useState([]);
  const [name, setName] = useState("");
  const [classId, setClassId] = useState("");

  useEffect(() => { api.get("/classes").then((r) => setClasses(r.data)); }, []);

  useEffect(() => {
    if (student && classes.length && !classes.some((c) => c.id === student.class_id)) {
      setStudent(null);
      onChange(null);
    }
  }, [student, classes, onChange]);

  if (student)
    return (
      <div className="ink-box-sm flex flex-wrap items-center gap-3 rounded-2xl bg-white px-4 py-3" data-testid="student-identity">
        <UserRound className="h-5 w-5" />
        <span className="font-bold">Ciao <span data-testid="student-name">{student.name}</span>! · Classe <span data-testid="student-class">{student.class_name}</span></span>
        <button onClick={() => { setStudent(null); onChange(null); }} data-testid="student-change-button" className="ml-auto text-sm font-extrabold underline">Non sei tu?</button>
      </div>
    );

  const save = (e) => {
    e.preventDefault();
    const cls = classes.find((c) => c.id === classId);
    if (!name.trim() || !cls) return toast.error("Scrivi il tuo nome e scegli la classe");
    const s = { name: name.trim().slice(0, 30), class_id: cls.id, class_name: cls.name };
    setStudent(s);
    onChange(s);
  };

  return (
    <form onSubmit={save} className="ink-box-sm flex flex-wrap items-end gap-3 rounded-2xl bg-white p-4" data-testid="student-form">
      <div className="min-w-48 flex-1">
        <label className="text-sm font-extrabold">Il tuo nome o soprannome</label>
        <input value={name} maxLength={30} onChange={(e) => setName(e.target.value)} data-testid="student-name-input" className="mt-1 w-full rounded-xl border-2 border-[var(--ink)] px-3 py-2 font-semibold outline-none" />
      </div>
      <div>
        <label className="text-sm font-extrabold">Classe</label>
        <select value={classId} onChange={(e) => setClassId(e.target.value)} data-testid="student-class-select" className="mt-1 block rounded-xl border-2 border-[var(--ink)] px-3 py-2 font-semibold">
          <option value="">Scegli…</option>
          {classes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <button data-testid="student-save-button" className="ink-box-sm ink-press rounded-full bg-[var(--sun)] px-5 py-2 font-extrabold">Salva</button>
      {classes.length === 0 && <p className="w-full text-xs font-semibold text-neutral-500" data-testid="no-classes-hint">Nessuna classe ancora: chiedi al tuo insegnante di crearla. Puoi comunque allenarti senza salvare i punti.</p>}
      <p className="w-full text-xs text-neutral-500">Così salviamo i tuoi punteggi su questo dispositivo e in classifica.</p>
    </form>
  );
};
